const tables = document.querySelectorAll('.variant__description')
// let params = new URLSearchParams(window.location.search)

 document.querySelectorAll('.swatch-element').forEach( function(variant) {
    variant.addEventListener('click', (e) => {
      setTimeout(function(){
      var priceEl = document.querySelector('#price-field span.money');
      var targetEl = document.querySelector('.metafield-money');
      if (priceEl && targetEl) {
        targetEl.innerHTML = priceEl.innerHTML + 'Brutto';
      }
      },200);
      let params = new URLSearchParams(window.location.search)
      e.stopPropagation();
      console.log(params.get('variant'));
 console.log(params.get('zonk'));


      tables.forEach( function(table) {
        table.style.display = 'none';

        // console.log(variant.dataset, table.dataset);
        if(params == table.dataset.variantId){
          table.style.display = 'block'
        }
      })
    })
  });
